module.exports = __webpack_public_path__ + "img/visualvault.56e87855.svg";